<template>
  <div class="chat-content">
    <message
      v-for="(message, index) in messages"
      :key="index"
      :message="message"
      :mkey="index"
    />
    <div v-if="$store.state.user.loading_indicator && !$store.state.user.streaming_message" class="chat-message waiting-chat-typing-indicator">
      <typing-indicator></typing-indicator>
    </div>
    <div
      v-if="lastMessageButtons && lastMessageButtons.length > 0"
      class="chat-buttons-container"
    >
      <button
        v-for="(button, index) in lastMessageButtons"
        v-show="button?.ignore !== true"
        :key="index"
        class="chat-buttons"
        @click="
          buttonClick({
            text: $t(button.name),
            value: button.value,
            text_without_t: button.name,
            action: button.action,
            live_coach_question: button.live_coach_question,
          })
        "
        v-html="$t(button.name)"
      />
    </div>
    <!-- <div v-if="$store.state.config.storeId != 28 && $store.state.config.storeId != 33 && $store.state.config.storeId != 37" class="poweredby">
      <p v-if="$store.state.config.storeId != 25 && $store.state.config.storeId != 47 && $store.state.config.storeId != 18 && $store.state.config.storeId != 46 && $store.state.config.storeId != 36 && $store.state.config.storeId != 26 && $store.state.config.storeId != 20 && $store.state.config.storeId != 42" class="powered">Powered by <a href="https://cleed.ai/" target="_blank">Cleed.ai</a></p>
      <p v-if="$store.state.config. || $store.state.config.storeId == 47 || $store.state.config.storeId == 18 || $store.state.config.storeId == 46 || $store.state.config.storeId == 36" class="powered" style="padding-top: 30em;">Powered by <a href="https://cleed.ai/" target="_blank">Cleed.ai</a></p>
      <p v-if="$store.state.config.storeId == 26 || $store.state.config.storeId == 20" class="powered" style="padding-top: 25em;">Powered by <a href="https://cleed.ai/" target="_blank">Cleed.ai</a></p>
      <p v-if="$store.state.config.storeId == 42" class="powered" style="padding-top: 27em;">Powered by <a href="https://cleed.ai/" target="_blank">Cleed.ai</a></p>
    </div> -->

    <AdminTypingIndicator v-if="$store.state.user.chat_typing_indicator" />
    <StreamingMessage v-if="$store.state.user.streaming_message" :message="$store.state.user.streaming_message" />
  </div>
</template>

<script>
import Message from "./Message.vue";
import AdminTypingIndicator from "./AdminTypingTracker";
import TypingIndicator from "./TypingIndicator.vue";
import { customLogger } from "@/utils";
import StreamingMessage from "./customs/Streaming_message.vue";

import utils from "../utils";

export default {
  name: "Chat",
  components: {
    Message,
    AdminTypingIndicator,
    TypingIndicator,
    StreamingMessage,
  },
  data: () => {
    return {
      number_messages: 0,
    };
  },
  computed: {
    messages() {
      const current_number_messages = this.$store.state.user.messages.length;

      if (current_number_messages != this.number_messages) {
        this.number_messages = current_number_messages;
      }
      return this.$store.state.user.messages;
    },
    lastMessageButtons() {
      const length = this.messages.length;

      if (this.messages[length - 1] && this.messages[length - 1].content)
        return this.messages[length - 1].content.buttons;
    },
  },
  watch: {
    number_messages(newValue) {
      utils.scrollDown();

      setTimeout(() => {
        utils.scrollDown();
      }, 1000);
    },
  },
  methods: {
    buttonClick(button) {
      const length = this.messages.length;

      // customLogger("test\n");

      if (
        this.messages[length - 1] &&
        this.messages[length - 1].content.on_click
      )
        eval(this.messages[length - 1].content.on_click)(button);

      if (this.$store.state.user.dislike_mode) {
        this.$eb.emit(
          "DislikeModeButtonClick",
          button,
          this.$store.state.user.data.tmp_content
        );
      } else if (
        this.$store.state.user.style_profile ||
        button.value === "Retour à l'accueil" ||
        button.value === "order_follow" ||
        //openai products recommendations
        button.value === "fetch_next_product_explanation_button_ok" ||
        button.value === "fetch_next_product_explanation_button_cancel" || 
        //formacast
        button.action === "qcm_results" || 
        button.action === "generate_questions" ||
        button.value === "restart_sub" 

      ){
        this.$eb.emit(
          "StyleButtonClick",
          button,
          this.$store.state.user.data.tmp_content
        );
      }
      else {
        // customLogger("BoxButtonClick", button);
        this.$eb.emit("BoxButtonClick", button);
      }
    },
  },
};
</script>